var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1253px",
    height: "1080px",
    viewBox: "0 0 1253 1080",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mobile-app") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created by Webpixels.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile-app"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.1,896.8 C79.1,896.8 -117,586.7 111.4,500.6 C339.8,414.5 618.3,494 713.1,248.4 C807.9,2.8 1280.4,-37.5 1251,172.5 C1221.6,382.5 984.7,584.7 966.8,784.5 C939.9,1086.8 282.6,1208.9 79.1,896.8 Z",
    id: "Path",
    fill: "#F1F2F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 941,
    y1: 1052.9,
    x2: 561.7,
    y2: 1052.9,
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(66.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.8,299.1 L77.8,285.3 C77.8,285.3 48.8,279.6 36.3,271.8 C23.8,264 -7.7,250.7 4.8,226.7 C11.3,214.3 48.4,233.2 63.1,241.2 C64.8,242.1 66.5,240 65.3,238.5 C59.2,231.1 51.2,220.5 52.4,217.3 C54.4,212.3 89.8,243.6 97.5,262.7 L113.4,273.1 L100.8,299.1 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,40.7 C298,40.7 303,20.7 285.6,8.1 C268.2,-4.5 251.9,1.5 245.8,4.9 C239.7,8.2 235,10.7 215.5,3.2 C196,-4.2 175.4,4.6 166.1,26.6 C156.8,48.6 154.3,66.9 168.9,86.9 C183.5,106.9 188.6,123.7 171.3,160.7 C154,197.7 174.3,240 176.7,247.4 C179.1,254.8 182.3,279.3 174.3,331.1 C174.3,331.1 213.4,342.8 239.6,320.9 C265.8,299 302.6,290.9 336.7,265.3 C370.8,239.7 350.2,196.2 350.2,196.2 L298,40.7 Z",
    id: "Path",
    fill: "#FFC933",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.6,25.5 C297.6,25.5 328.4,29.1 338.4,55.5 C348.4,81.9 371.1,142.5 385.4,161.3 L374,251.6 L332.2,268.7 L288.8,27.3 L297.6,25.5 Z",
    id: "Path",
    fill: "#FFC933",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.8,154.1 C303.8,154.1 321.6,177 328.9,191.3 C328.9,191.3 339.5,193.4 352.2,186.9 C364.9,180.4 356.8,167.9 356.8,167.9 L323,142.3 C323,142.3 305.1,142.3 303.8,154.1 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,189.6 C328,189.6 308.7,238.6 303.4,250.8 C298,263.1 398,384.4 403.7,385.6 C409.4,386.8 505.7,308.4 511.9,288.2 C518.1,268.1 414.9,162.7 414.9,162.7 C414.9,162.7 387.1,163.7 356.9,167.9 C356.9,167.9 354.8,177.9 346.5,184.3 C338,190.6 328,189.6 328,189.6 Z",
    id: "Path",
    fill: "#396cf0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,40.7 C298,40.7 303,20.7 285.6,8.1 C268.2,-4.5 251.9,1.5 245.8,4.9 C239.7,8.2 235,10.7 215.5,3.2 C196,-4.2 175.4,4.6 166.1,26.6 C156.8,48.6 154.3,66.9 168.9,86.9 C183.5,106.9 188.6,123.7 171.3,160.7 C154,197.7 174.3,240 176.7,247.4 C179.1,254.8 182.3,279.3 174.3,331.1",
    id: "Path",
    stroke: "#FEAC00",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#396cf0",
    fillRule: "nonzero",
    points: "303.4 250.9 240.5 338.7 119.7 242.8 86.4 319.7 239.6 398.7 340.1 310.4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.9,
    y1: 243.4,
    x2: 37.8,
    y2: 262.2,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 232.9,
    x2: 42.8,
    y2: 253.2,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.7,
    y1: 224.5,
    x2: 46.9,
    y2: 244.8,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,48.9 C324.3,77.6 337.9,135.4 316,150.4 C294.1,165.4 245.1,132.1 225.3,103.4 C205.5,74.7 217,53.4 238.9,38.4 C260.8,23.3 284.8,20.2 304.5,48.9 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(167.000000, 470.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.9,390.2 C149.9,390.2 132.3,327.2 127,261 C121.7,194.8 127.4,117.7 138.4,108.7 C149.4,99.7 157.2,118.1 158.4,121.4 C159.6,124.7 180,195.7 177.2,268.4 C174.3,341.1 155.7,404.4 155.7,404.4 L149.9,390.2 Z",
    id: "Path",
    fill: "#FFB3DA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5,87.2 C61.5,87.2 91.9,204 112.9,277.4 C133.9,350.8 189.2,485.6 189.2,485.6",
    id: "Path",
    stroke: "#52CB96",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#37B37F",
    fillRule: "nonzero",
    cx: 47.2,
    cy: 46.5,
    r: 46.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.4,487.6 C187.4,487.6 103.7,396.3 78.9,355.1 C54.1,313.9 29.3,254.4 36.1,241.2 C42.9,228 81.2,259.8 108.7,312.4 C140.9,373.9 187.7,484 187.7,484 L187.4,487.6 Z",
    id: "Path",
    fill: "#FFB3DA",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M921.9,616.2 C921.9,616.2 947.5,478.2 1007.5,380.2 C1067.5,282.2 1101.8,279.8 1095.7,305.5 C1089.6,331.2 1003.9,580.5 910.8,709.4 L921.9,616.2 Z",
    id: "Path",
    fill: "#FFB3DA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.5,703 C911.5,703 984.2,564.6 1068.7,515.6 C1153.2,466.6 1163.6,491.7 1171,500.6 C1178.3,509.5 1181.9,575.2 1046.7,693.2 C921.8,802.2 899.1,806.7 899.1,806.7 L911.5,703 Z",
    id: "Path",
    fill: "#52CB96",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(349.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.8,1057.4 L60.6,990.3 C39.8,987.6 25.1,968.5 27.8,947.7 L123.1,42.2 C141.9,11.5 191.8,-2.2 212.6,0.5 L598,50.7 C626.5,54.4 646.9,80.8 643.1,109.4 L525.5,1012.5 C521.2,1046.2 471.6,1060.1 450.8,1057.4 Z",
    id: "Path",
    fill: "#396cf0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.7,1057.5 L31.4,1003.2 C12.1,1000.7 -1.4,983.1 1.1,963.8 L119.9,51.5 C122.4,32.2 140,18.7 159.3,21.2 L576.6,75.5 C595.9,78 609.4,95.6 606.9,114.9 L488.1,1027.2 C485.6,1046.4 468,1060 448.7,1057.5 Z",
    id: "Path",
    fill: "#305ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1F2F7",
    transform: "translate(301.636965, 538.912420) rotate(7.388674) translate(-301.636965, -538.912420) ",
    x: 63.9861511,
    y: 100.710919,
    width: 475.301628,
    height: 876.403002
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1F2F7",
    transform: "translate(364.051750, 77.090670) rotate(7.417821) translate(-364.051750, -77.090670) ",
    x: 299.353776,
    y: 72.5908109,
    width: 129.395948,
    height: 8.99971816
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.8,576.6 L115,529.9 C107.7,528.9 102.5,522.2 103.4,514.9 L103.7,512.8 C104.7,505.5 111.4,500.3 118.7,501.2 L477.5,547.9 C484.8,548.9 490,555.6 489.1,562.9 L488.8,565 C487.9,572.4 481.1,577.6 473.8,576.6 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.3,641.9 L106.5,595.2 C99.2,594.2 94,587.5 94.9,580.2 L95.2,578.1 C96.2,570.8 102.9,565.6 110.2,566.5 L469,613.2 C476.3,614.2 481.5,620.9 480.6,628.2 L480.3,630.3 C479.4,637.7 472.6,642.9 465.3,641.9 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.8,707.2 L98,660.5 C90.7,659.5 85.5,652.8 86.4,645.5 L86.7,643.4 C87.7,636.1 94.4,630.9 101.7,631.8 L460.5,678.5 C467.8,679.5 473,686.2 472.1,693.5 L471.8,695.6 C470.9,703 464.1,708.2 456.8,707.2 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.3,772.5 L89.5,725.8 C82.2,724.8 77,718.1 77.9,710.8 L78.2,708.7 C79.2,701.4 85.9,696.2 93.2,697.1 L452,743.8 C459.3,744.8 464.5,751.5 463.6,758.8 L463.3,760.9 C462.4,768.3 455.6,773.4 448.3,772.5 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.9,814.5 L81,791 C73.7,790 68.5,783.3 69.4,776 L69.7,773.9 C70.7,766.6 77.4,761.4 84.7,762.3 L264.6,785.7 C271.9,786.7 277.1,793.4 276.2,800.7 L275.9,802.8 C275,810.2 268.3,815.4 260.9,814.5 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#396cf0",
    cx: 331.9,
    cy: 324.8,
    r: 136.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.7,940.9 L82.2,919.5 C65.2,917.3 53.1,901.6 55.3,884.6 L55.9,879.6 C58.1,862.6 73.8,850.5 90.8,852.7 L255.3,874.1 C272.3,876.3 284.4,892 282.2,909 L281.6,914 C279.5,931 263.7,943.1 246.7,940.9 Z",
    id: "Path",
    fill: "#396cf0"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 907.9,
    y1: 756.4,
    x2: 1103.9,
    y2: 545.5,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileApp);
export default __webpack_public_path__ + "static/media/mobile-app.5c21d3b04b0ac91015c7d41d7e8e4cad.svg";
export { ForwardRef as ReactComponent };